// @ts-nocheck
import withGoogleTag from '../../Analytics/GTag/withGoogleTag'
import { PageCard } from './index'

const PageCardWithGoogleTag = withGoogleTag(PageCard)

export default PageCardWithGoogleTag
